/* eslint-disable indent */
/* global initCookieConsent Splide */
import $ from './jquery-global';
import { setupAjaxUtils, useAjaxAutoBrowserHistoryUpdate } from './ajax-utils';
import { initMirtilletoChristmas } from './mirtilleto-christmas';

import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import Clipboard from 'clipboard';

window.Splide = Splide;

//import { Modal, BackToTop, Tab, Dropdown, NavBarCollapsible } from 'bootstrap-italia'
//import { loadFonts } from 'bootstrap-italia'

import { Fancybox } from "@fancyapps/ui";
import { it } from '@fancyapps/ui/dist/fancybox/l10n/it.esm.js';
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import 'sharer.js';

import '../scss/application.scss';

$(function () {
	// initialize ajax-utils
	setupAjaxUtils();
	initMirtilletoChristmas();
	// initialize tags dropdowns
	//initTagsDropdowns();
});

// Inizializza le dropdown dei tag dopo il caricamento della pagina o dopo un reload AJAX
//function initTagsDropdowns() {
//	$('[data-tags-dropdown]').each(function () {
//		var $dropdown = $(this);
//		var form = $dropdown.closest('form')[0];

//		// Assicura che il valore selezionato sia visibile
//		var selectedValue = $dropdown.val();
//		if (selectedValue) {
//			// Se c'è un valore selezionato, aggiorna il display
//			//$dropdown.trigger('change.select2');

//			// Disabilita i pulsanti categoria se un tag è selezionato
//			//if (form) {
//			//	var categoryIdButtons = form.querySelectorAll('button[name="CategoryId"]');
//			//	categoryIdButtons.forEach(function (btn) {
//			//		btn.disabled = true;
//			//	});
//			//}
//		} else {
//			// Assicura che i pulsanti categoria siano abilitati se nessun tag è selezionato
//			//if (form) {
//			//	var categoryIdButtons = form.querySelectorAll('button[name="CategoryId"]');
//			//	categoryIdButtons.forEach(function (btn) {
//			//		btn.disabled = false;
//			//	});
//			//}
//		}
//	});
//}

// Hook per reinizializzare le dropdown dopo un aggiornamento AJAX
$(document).ajaxSuccess(function () {
	initMirtilletoChristmas();
	//initTagsDropdowns();
});

// Gestione filtri Sedi List - Esportate come funzioni globali
window.handleCategoryButtonClick = function (button) {
	var form = document.getElementById('sediFilterForm');
	if (!form) {
		// Fallback: cerca il form più vicino
		form = button.closest('form');
	}

	// Rimuove tutti i tag selezionati
	clearAllTags(form);

	// Reset di tutte le dropdown tags
	var allTagsDropdowns = form.querySelectorAll('[data-tags-dropdown]');
	allTagsDropdowns.forEach(function (dropdown) {
		dropdown.value = '';
	});

	return true; // Continua con il submit del form (che sarà AJAX grazie alla classe ajax-form)
};

window.handleTagsDropdownChange = function (dropdown) {
	var form = dropdown.closest('form');
	var selectedValue = dropdown.value;

	// Rimuove tutti i tag precedenti
	clearAllTags(form);

	// Reset di tutte le altre dropdown tags
	var allTagsDropdowns = form.querySelectorAll('[data-tags-dropdown]');
	allTagsDropdowns.forEach(function (otherDropdown) {
		if (otherDropdown !== dropdown) {
			otherDropdown.value = '';
		}
	});

	// Gestisce i pulsanti delle categorie
	var categoryIdButtons = form.querySelectorAll('button[name="CategoryId"]');

	if (selectedValue) {
		// Un tag è stato selezionato - disabilita i pulsanti categoria
		categoryIdButtons.forEach(function (btn) {
			btn.disabled = true;
		});

		// Aggiunge il nuovo tag selezionato
		var hiddenInput = document.createElement('input');
		hiddenInput.type = 'hidden';
		hiddenInput.name = 'tags';
		hiddenInput.value = selectedValue;
		hiddenInput.className = 'selected-tag-input';
		form.appendChild(hiddenInput);
	} else {
		// L'opzione vuota è stata selezionata - riabilita i pulsanti categoria
		categoryIdButtons.forEach(function (btn) {
			btn.disabled = false;
		});
	}

	// Trigger del submit AJAX
	$(form).submit();
};

// Funzione helper per rimuovere tutti i tag selezionati
function clearAllTags(form) {
	var tagInputs = form.querySelectorAll('.selected-tag-input');
	tagInputs.forEach(function (input) {
		input.remove();
	});
}

//$(function () {
//	document.querySelectorAll('.page-content').forEach(section => {
//		let i = 0;
//		section.querySelectorAll('img').forEach(img => {
//			// opzionale: salta immagini "speciali" (gallerie/caption)
//			if (img.closest('figure, .wp-caption')) return;

//			// pulisci classi pregresse
//			img.classList.remove('alignleft', 'alignright');

//			// alterna
//			img.classList.add((i++ % 2) ? 'alignright' : 'alignleft');
//		});
//	});
//})

$(function () {
	var elms = document.getElementsByClassName('splide');

	for (var i = 0; i < elms.length; i++) {
		const splide = new Splide(elms[i])
		splide.on('mounted', () => {
			const root = splide.root;

			const prev = root.querySelector('.splide__arrow--prev');
			const next = root.querySelector('.splide__arrow--next');
			const arrows = root.querySelector('.splide__arrows');
			const pagination = root.querySelector('.splide__pagination');
			const slideTitle = root.querySelectorAll('.slide-title');

			if (!prev || !next || !pagination) return;

			// Crea il wrapper inline
			const controls = document.createElement('div');
			controls.className = 'splide__controls-inline';

			const controlsButtons = document.createElement('div');
			controlsButtons.className = 'splide__control-buttons';


			if (slideTitle.length) {
				controls.appendChild(slideTitle[0].cloneNode(true));
			}

			controls.appendChild(controlsButtons);

			// Ordine richiesto: prev | pagination | next
			controlsButtons.appendChild(prev);
			controlsButtons.appendChild(pagination);
			controlsButtons.appendChild(next);

			// Inserisci i controlli dove preferisci.
			// Qui li piazzo subito dopo il track.
			const track = root.querySelector('.splide__track');
			track.after(controls);

			// Rimuovi il vecchio contenitore delle frecce (vuoto ormai)
			arrows?.remove();
		});

		splide.mount();

		splide.on('move', function (newIndex, prevIndex, destIndex) {
			const root = splide.root;
			const slideTitle = $(`.splide__slide:eq(${destIndex}) .slide-title`, root);
			if (!$(slideTitle).length) return;
			const controls = root.querySelector('.splide__controls-inline');
			//$(controls).find(".slide-title").remove()
			$(controls).find(".slide-title").html($(slideTitle).html())
		});
	}
})

const header = document.querySelector("header");
const headerSlim = document.querySelector(".it-header-slim-wrapper")
const headerCenter = document.querySelector(".it-header-center-wrapper")

const onScroll = () => {
	if (window.scrollY > (headerSlim ? headerSlim.offsetHeight + headerCenter.offsetHeight : header.offsetHeight)) {
		header.classList.add("is-sticky")
	} else {
		header.classList.remove("is-sticky")
		$(headerCenter).addClass("scrolled")
	}
}
// clean up code
window.removeEventListener('scroll', onScroll);
window.addEventListener('scroll', onScroll, { passive: true });

//var lastScrollTop = 0;

//window.addEventListener("scroll", function () { // or window.addEventListener("scroll"....
//	var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
//	if (st > lastScrollTop) {
//		console.log("down")
//		header.classList.add("scroll-down")
//	} else if (st < lastScrollTop) {
//		console.log("up")
//		header.classList.remove("scroll-down")
//	} // else was horizontal scroll
//	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
//}, false);


//const backToTopElement = document.getElementById('backtotop');
//const backToTop = new BackToTop(backToTopElement, {
//	scrollLimit: 200
//});

$(function () {
	$("div.megamenu .nav-tabs a").on("click", function (ev) {
		//console.log(ev)
		ev.stopImmediatePropagation()
		ev.preventDefault();
		ev.stopPropagation();
		if ($(".navbar-nav button.nav-link.active").length) {
			$(this).closest(".nav-item").find(".nav-link:eq(0)").removeClass("active")
		}
		return false;
	})



})

$(function () {
	$("div.megamenu .nav-tabs").each((ii, el) => {
		if (!$(el).find("a.active").length) {
			$(el).find("a:eq(0)").addClass("active")
		}
	})
	$("div.megamenu .tab-content").each((ii, el) => {
		if (!$(el).find(".tab-pane.active").length) {
			$(el).find(".tab-pane:eq(0)").addClass("active")
		}
	})
})

$(function () {
	document.querySelectorAll('[data-fancybox]').forEach(el => {
		const group = el.dataset.fancybox; // oppure el.getAttribute('data-fancybox')
		console.log('group:', group);
		Fancybox.bind(`[data-fancybox="${group}"]`, {
			groupAll: true,
			l10n: it
		});
	});

	//Fancybox.bind(".gallery-trigger", {
	//	groupAll: true,
	//	l10n: it
	//});
})


$(function () {
	const container = document.querySelector('.lista-colonne');
	if (!container) return;

	// Idempotenza: se è già stato trasformato, esci.
	if ([...container.children].some(c => c.classList.contains('lista-colonne-col'))) return;

	const nodes = Array.from(container.childNodes);
	const cols = [];
	let currentCol = null;
	let buffer = [];

	const isWS = n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() === '';

	// Rimuove tutti i <br> da un subtree
	const stripBr = (root) => {
		const brs = root.querySelectorAll ? root.querySelectorAll('br') : [];
		brs.forEach(br => br.remove());
	};

	// Commit del buffer come .lista-colonne-item nella colonna corrente
	function commitBuffer() {
		// pulizia whitespace
		const meaningful = buffer.filter(n => !isWS(n));
		buffer = [];
		if (meaningful.length === 0) return;

		// Se non c'è una colonna attiva, creane una "senza titolo"
		if (!currentCol) {
			currentCol = document.createElement('div');
			currentCol.className = 'lista-colonne-col';
			cols.push(currentCol);
		}

		const item = document.createElement('div');
		item.className = 'lista-colonne-item';
		meaningful.forEach(n => item.appendChild(n));
		currentCol.appendChild(item);
	}

	nodes.forEach(n => {
		// Skippa e droppa tutti i <br> (li eliminiamo)
		if (n.nodeName === 'BR') {
			commitBuffer();
			return;
		}

		// Titolo: chiudi la riga pendente, apri una nuova colonna e inserisci il titolo
		if (n.nodeType === Node.ELEMENT_NODE && n.classList.contains('titolo-lista')) {
			commitBuffer();

			// Crea nuova colonna
			currentCol = document.createElement('div');
			currentCol.className = 'lista-colonne-col';
			cols.push(currentCol);

			// Usa il nodo titolo "as-is", ma senza eventuali <br> interni
			// (il markup originale li mette dentro al titolo)
			stripBr(n);
			currentCol.appendChild(n);
			return;
		}

		// Accumula qualunque altro nodo (testo, span, ecc.)
		buffer.push(n);
	});

	// Flush finale
	commitBuffer();

	// Ricostruisci il contenuto del container senza <br>
	container.innerHTML = '';
	cols.forEach(col => container.appendChild(col));
});




/*
 *  Sharer JS visual handler
 */
$(function () {
	$(".sharer-trg").each(function () {
		var $currentElement = $(this);
		$currentElement.on("click", function (ev) {
			ev.preventDefault();
			setTimeout(function () {
				$(".social-bar").not($currentElement.find(".social-bar")).removeClass("active");
				$currentElement.find($(".social-bar")).toggleClass("active");
			}, 200);
		});
	});

	$(document).on("click", (ev) => {
		//console.log(ev.target); 
		if ($(ev.target).hasClass("sharer-trg") || $(ev.target).closest(".sharer-trg").length) return;
		$(".social-bar").removeClass("active");
	})
});

$(function () {
	var clipboard = new Clipboard('.clipboard');

	clipboard.on('success', function (e) {
		$(e.trigger).removeClass("btn-info").addClass("btn-danger").find("i").removeClass("bi-copy").addClass("bi-check2");

		setTimeout(function () {
			$(e.trigger).removeClass("btn-danger").addClass("btn-info").find("i").removeClass("bi-check2").addClass("bi-copy");
		}, 3000);
	});

	clipboard.on('error', function (e) {
		var originalText = $(e.trigger).text();
		$(e.trigger).text('Retry!');

		setTimeout(function () {
			$(e.trigger).text(originalText);
		}, 3000);
	});
})

$(function () {
	var target = $(".section-counters");
	if (!target.length) return false;
	var options = {
		threshold: 0.1
	};

	var callback = function (entries, observer) {
		entries.forEach(entry => {
			// calcolo la percentuale di sovrapposizione
			const ratio = entry.intersectionRatio;
			const element = entry.target;
			// se l'elemento è visibile
			if (ratio > 0) {
				// start all the timers
				$('.timer').each(count);
				// rimuovo l'elemento dall'observer
				//observer.unobserve(element);
			}
		});
	};

	var observer = new IntersectionObserver(callback, options);
	observer.observe(target[0]);

	$.fn.countTo = function (options) {
		options = options || {};

		return $(this).each(function () {
			// set options for current element
			var settings = $.extend({}, $.fn.countTo.defaults, {
				from: $(this).data('from'),
				to: $(this).data('to'),
				suffix: $(this).data('suffix'),
				speed: $(this).data('speed'),
				refreshInterval: $(this).data('refresh-interval'),
				decimals: $(this).data('decimals')
			}, options);

			// how many times to update the value, and how much to increment the value on each update
			var loops = Math.ceil(settings.speed / settings.refreshInterval),
				increment = (settings.to - settings.from) / loops;

			// references & variables that will change with each update
			var self = this,
				$self = $(this),
				loopCount = 0,
				value = settings.from,
				data = $self.data('countTo') || {};

			$self.data('countTo', data);

			// if an existing interval can be found, clear it first
			if (data.interval) {
				clearInterval(data.interval);
			}
			data.interval = setInterval(updateTimer, settings.refreshInterval);

			// initialize the element with the starting value
			render(value);

			function updateTimer() {
				value += increment;
				loopCount++;

				render(value);

				if (typeof (settings.onUpdate) == 'function') {
					settings.onUpdate.call(self, value);
				}

				if (loopCount >= loops) {
					// remove the interval
					$self.removeData('countTo');
					clearInterval(data.interval);
					value = settings.to;

					if (typeof (settings.onComplete) == 'function') {
						settings.onComplete.call(self, value);
					}
				}
			}

			function render(value) {
				var formattedValue = settings.formatter.call(self, value, settings);
				$self.html(formattedValue);
			}
		});
	};

	$.fn.countTo.defaults = {
		from: 0, // the number the element should start at
		to: 0, // the number the element should end at
		speed: 1000, // how long it should take to count between the target numbers
		suffix: null,
		refreshInterval: 20, // how often the element should be updated
		decimals: 0, // the number of decimal places to show
		formatter: formatter, // handler for formatting the value before rendering
		onUpdate: null, // callback method for every time the element is updated
		onComplete: null // callback method for when the element finishes updating
	};

	function formatter(value, settings) {
		return value.toFixed(settings.decimals);
	}

	function count(options) {
		var $this = $(this);

		// Opzioni di base (come prima)
		options = $.extend({}, options || {}, $this.data('countToOptions') || {});

		// Salvo eventuali callback originali per non rompere nulla
		var originalOnUpdate = options.onUpdate;
		var originalOnComplete = options.onComplete;

		// Blocco del numero
		var $hNumber = $this.closest('.h-number');
		var $progress = $hNumber.find('.progress').first(); // se non c'è, comportamento identico al passato

		if ($progress.length) {

			var $caption = $hNumber.find('.h-number-caption').first();

			// Larghezze disponibili
			var containerWidth = $hNumber.innerWidth();
			var captionWidth = $caption.outerWidth(true) || 0;

			// Spazio massimo per la barra (100% - caption)
			var maxAvailableWidth = Math.max(containerWidth - captionWidth, 0);

			// Trovo il valore massimo tra TUTTI i .timer (serve per la proporzione)
			var maxTo = 0;
			$('.timer').each(function () {
				var v = parseFloat($(this).data('to')) || 0;
				if (v > maxTo) maxTo = v;
			});
			if (!maxTo) {
				maxTo = parseFloat($this.data('to')) || 1;
			}

			// Valori from/to per questo specifico counter
			var from = typeof options.from !== 'undefined' ? options.from : (parseFloat($this.data('from')) || 0);
			var to = typeof options.to !== 'undefined' ? options.to : (parseFloat($this.data('to')) || 0);
			var total = to - from || 1; // evito divisione per 0

			// Larghezza finale di QUESTA barra in base al numero
			// es: se to = maxTo → finalWidth = maxAvailableWidth
			// se to = maxTo / 2 → finalWidth ≈ metà
			var ratioToMax = to / maxTo;
			// se vuoi evitare barre troppo corte, puoi forzare un minimo, tipo:
			// ratioToMax = Math.max(ratioToMax, 0.2);
			var finalWidth = maxAvailableWidth * ratioToMax - 50;

			// Setup iniziale barra
			$progress.css({
				maxWidth: maxAvailableWidth + 'px',
				width: 0
			});

			// Gestione eventuale .progress-bar interna (tipo Bootstrap)
			var $bar = $progress.find('.progress-bar').first();
			if ($bar.length) {
				$bar.css('width', '0%');
			}

			// Hookiamo l'update del countTo
			options.onUpdate = function (value) {
				var progressRatio = (value - from) / total;
				progressRatio = Math.min(Math.max(progressRatio, 0), 1); // clamp 0–1

				// Larghezza attuale proporzionale all'avanzamento del numero
				var currentWidth = finalWidth * progressRatio;
				$progress.css('width', currentWidth + 'px');

				if ($bar.length && maxAvailableWidth > 0) {
					var percentOfSlot = (currentWidth / maxAvailableWidth) * 100;
					$bar.css('width', percentOfSlot + '%');
				}

				if (typeof originalOnUpdate === 'function') {
					originalOnUpdate.call(this, value);
				}
			};

			// A fine animazione ci assicuriamo che sia sul target calcolato
			options.onComplete = function (value) {
				$progress.css('width', finalWidth + 'px');

				if ($bar.length && maxAvailableWidth > 0) {
					var percentOfSlot = (finalWidth / maxAvailableWidth) * 100;
					$bar.css('width', percentOfSlot + '%');
				}

				if (typeof originalOnComplete === 'function') {
					originalOnComplete.call(this, value);
				}
			};
		}

		// Comportamento originale: faccio partire il count
		$this.countTo(options);
	}

	// custom formatting example
	$('.count-number').data('countToOptions', {
		formatter: function (value, options) {
			return (value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, '.') + (options.suffix ? "<small>" + options.suffix + "</small>" : ""));
		}
	});

});

(function () {
	"use strict";

	function px(value) {
		if (value === null || value === undefined) return "";
		if (typeof value === "number") return value + "px";
		value = String(value).trim();
		if (!value) return "";
		return (/^\d+(\.\d+)?$/.test(value)) ? (value + "px") : value;
	}

	function getIframeSize(iframe) {
		var cs = window.getComputedStyle ? window.getComputedStyle(iframe) : null;

		var width = (cs && cs.width && cs.width !== "auto") ? cs.width : "";
		var height = (cs && cs.height && cs.height !== "auto") ? cs.height : "";

		if (!width) width = px(iframe.getAttribute("width"));
		if (!height) height = px(iframe.getAttribute("height"));

		if (!width) width = px(iframe.clientWidth || iframe.offsetWidth);
		if (!height) height = px(iframe.clientHeight || iframe.offsetHeight);

		return {
			width: width || "100%",
			height: height || "250px"
		};
	}

	function buildPlaceholder(size) {
		var wrapper = document.createElement("div");
		wrapper.className = "privacy-iframe-placeholder";
		wrapper.style.width = size.width;
		wrapper.style.height = size.height;
		wrapper.style.display = "flex";
		wrapper.style.flexDirection = "column";
		wrapper.style.alignItems = "center";
		wrapper.style.justifyContent = "center";
		wrapper.style.textAlign = "center";
		wrapper.style.boxSizing = "border-box";
		wrapper.style.padding = "16px";
		wrapper.style.border = "1px solid rgba(0,0,0,.15)";
		wrapper.style.background = "rgba(0,0,0,.03)";

		var message = document.createElement("div");
		message.className = "fw-bold fs-10 lh-sm";
		message.textContent = "Per visualizzare questo contenuto è necessario cambiare le tue preferenze relative alla privacy";
		message.style.maxWidth = "700px";

		var button = document.createElement("button");
		button.type = "button";
		button.className = "btn btn-warning privacy-iframe-placeholder__button";
		button.textContent = "Modifica le tue preferenze privacy";
		button.style.marginTop = "12px";

		button.addEventListener("click", function (ev) {
			ev.preventDefault();
			var link = document.querySelector(".iubenda-cs-preferences-link");
			if (link) link.click();
		});

		wrapper.appendChild(message);
		wrapper.appendChild(button);

		return wrapper;
	}

	function replaceSuppressedIframes() {
		var iframes = document.querySelectorAll("iframe[data-suppressedsrc]");
		for (var i = 0; i < iframes.length; i++) {
			var iframe = iframes[i];

			// Avoid double-processing
			if (iframe.getAttribute("data-privacy-placeholder") === "1") continue;

			var size = getIframeSize(iframe);
			var placeholder = buildPlaceholder(size);

			// Try to preserve margins to keep layout consistent
			var cs = window.getComputedStyle ? window.getComputedStyle(iframe) : null;
			if (cs) {
				placeholder.style.marginTop = cs.marginTop;
				placeholder.style.marginRight = cs.marginRight;
				placeholder.style.marginBottom = cs.marginBottom;
				placeholder.style.marginLeft = cs.marginLeft;
			}

			iframe.setAttribute("data-privacy-placeholder", "1");
			iframe.parentNode.appendChild(placeholder, iframe);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", replaceSuppressedIframes);
	} else {
		replaceSuppressedIframes();
	}
})();

// Sposta le immagini inline con longdesc in un wrapper con caption (idempotente)
$(function () {
	function moveInlineImagesWithLongdesc() {
		// limita al contenuto articoli (evita header/footer ecc.)
		var imgs = document.querySelectorAll('.item-text img[longdesc]')
		//console.log(imgs.length)
		for (var i = 0; i < imgs.length; i++) {
			var img = imgs[i];
			var isOnTheRight = img.classList.contains('img-right');

			// longdesc valorizzato
			var longdesc = (img.getAttribute('longdesc') || '').trim();
			if (!longdesc) continue;

			// idempotenza: se già wrappata, salta
			if (img.closest('.item-img-container')) continue;

			// crea container
			var container = document.createElement('div');
			container.className = 'item-img-container';
			if (isOnTheRight) {
				container.classList.add('img-right');
			}


			// crea caption
			var caption = document.createElement('div');
			caption.className = 'item-img-caption';
			caption.innerHTML = longdesc;

			// inserisce il container al posto dell'immagine e poi sposta img + caption dentro
			var parent = img.parentNode;
			parent.insertBefore(container, img);
			container.appendChild(img);
			container.appendChild(caption);

			// opzionale: pulisci longdesc per evitare duplicazioni/tooltip
			// img.removeAttribute('longdesc');
		}
	}

	moveInlineImagesWithLongdesc();

	// se pagine/caricamenti AJAX rimpiazzano contenuti, riprova dopo ogni ajaxSuccess
	$(document).ajaxSuccess(function () {
		moveInlineImagesWithLongdesc();
	});
});


document.addEventListener('DOMContentLoaded', () => {

	const videos = document.querySelectorAll('video');

	videos.forEach((video) => {
		// Evita di wrappare due volte lo stesso video
		if (video.closest('.video-wrapper')) return;

		// Crea wrapper
		const wrapper = document.createElement('div');
		wrapper.classList.add('video-wrapper');

		// Inserisci il wrapper al posto del video
		video.parentNode.insertBefore(wrapper, video);
		wrapper.appendChild(video);

		// Disattiva i controls inizialmente (li attiviamo al play)
		video.controls = false;

		// Crea bottone play
		const playButton = document.createElement('button');
		playButton.type = 'button';
		playButton.classList.add('video-play-button');
		playButton.setAttribute('aria-label', 'Riproduci video');

		// Icona interna (stilizzata da CSS)
		const icon = document.createElement('span');
		icon.classList.add('video-play-icon');
		playButton.appendChild(icon);

		// Append bottone nel wrapper
		wrapper.appendChild(playButton);

		const startPlayback = () => {
			// Se il video è già in play, non fare niente
			if (!video.paused && !video.ended) return;

			video.play().catch((err) => {
				// in caso di blocco autoplay ecc.
				console.warn('Impossibile riprodurre il video:', err);
			});
		};

		// Click sul bottone play
		playButton.addEventListener('click', (e) => {
			e.stopPropagation();
			startPlayback();
		});

		// (Opzionale) click sul video fa partire il play
		video.addEventListener('click', () => {
			startPlayback();
		});

		// Quando parte il video, nascondi il bottone e mostra i controls
		video.addEventListener('play', () => {
			playButton.classList.add('is-hidden');
			video.controls = true;
		});

		// Quando il video finisce, ri-mostra il bottone
		video.addEventListener('ended', () => {
			playButton.classList.remove('is-hidden');
			// se vuoi riportare il video all'inizio:
			// video.currentTime = 0;
		});

		// Se viene messo in pausa molto all'inizio o alla fine, puoi far riapparire il bottone
		video.addEventListener('pause', () => {
			// Se vuoi che ricompaia SEMPRE in pausa, basta togliere il controllo sull'istante:
			//if (video.currentTime === 0 || video.currentTime >= video.duration - 0.1) {
			playButton.classList.remove('is-hidden'); 
			//}
		});
	});
});